import lodash from 'lodash';
import React from 'react';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import {
    withStyles,
    TextField,
    FormHelperText,
    FormControlLabel,
    Typography,
    Checkbox,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Row, Col } from 'antd';
import { red as colorRed, green as colorGreen } from '@material-ui/core/colors';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA, VIEW_PAYMENT_APPROVAL_URL } from '../../constants';
import { IMAGES, DOCS, PDF } from '../../../../../common/constants/fileTypes';
import { SYSTEM_USER } from '../../../../../common/constants';
import styles from './styles';
import { readLeadProfileLeadFinanceSuccess } from '../../../Lead_profile/redux/actions/lead_profile_lead_finance.actions';

const ACCEPTED_FILE_TYPES = [].concat(IMAGES, DOCS, PDF);
class PreTransactionDetails extends React.Component {
    handleChangeField = (key, value) => {
        const { dispatch, dataModel } = this.props;

        dataModel.set(key, value);

        dispatch(readLeadProfileLeadFinanceSuccess(dataModel._doc));

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            payload: {
                dataModel,
                $lastUpdateTime: Date.now(),
            },
        });
    }

    buildApprovalHistory(pattern) {
        const { dataModel, data } = this.props;
        const updatedBy = dataModel.get(`bought_info.${pattern}_team_approval.updated_by`);
        const updatedAt = dataModel.get(`bought_info.${pattern}_team_approval.updated_date`);
        const userId = lodash.get(data, `bought_info.${pattern}_team_approval.updated_by._id`);
        let result = null;

        if (updatedBy && updatedAt && userId !== SYSTEM_USER) {
            result = `Last update by ${updatedBy} at ${moment(updatedAt).format('D MMM HH:mm')}`;
        }

        return result;
    }

    handleUploadFile = (newFileObjects) => {
        const { dispatch, dataModel } = this.props;

        dataModel.set('settlement_proof', newFileObjects[0]);

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
            payload: {
                dataModel,
                $lastUpdateTime: Date.now(),
            },
        });
    }

    handleDownloadFile = () => {
        const { dataModel } = this.props;
        const proof = dataModel.settlement_proof;
        const isUploadedFile = Boolean(lodash.get(proof, 'file._id'));
        let fileName;
        let fileUrl;

        if (isUploadedFile) {
            fileName = proof.file.name;
            fileUrl = proof.file.url;
        } else {
            fileName = proof.file.name;
            fileUrl = proof.data;
        }

        if (fileName && fileUrl) {
            let link = document.createElement('a');

            link.download = fileName;
            link.href = fileUrl;
            link.target = '_blank';
            link.click();
            link = null;
        }
    }

    getValue(path, canBeZero, fixedDecimal) {
        const { dataModel } = this.props;

        let value = dataModel.get(path);

        if (value === 0 && canBeZero) {
            return 0;
        }

        if (fixedDecimal) {
            value = lodash.floor(value, 2);
        }

        return value || '';
    }

    render() {
        const {
            isLoading,
            dataModel,
            sourceScreen,
            classes,
            formIsLocked,
        } = this.props;
        const isPaymentScreen = sourceScreen === VIEW_PAYMENT_APPROVAL_URL;
        const finTree = dataModel.schema.tree;
        const boughtTree = finTree.bought_info.type.tree;
        const custNameV5Tree = boughtTree.customer_name_v5.type.tree;
        const purchasingTree = boughtTree.purchasing_team_approval.type.tree;
        const transportTree = boughtTree.transport_team_approval.type.tree;
        const accountsTree = boughtTree.accounts_team_approval.type.tree;
        const purApprovalHistory = this.buildApprovalHistory('purchasing');
        const transApprovalHistory = this.buildApprovalHistory('transport');
        const accApprovalHistory = this.buildApprovalHistory('accounts');

        return (
            <Row>
                <Col span={24}>
                    <Typography variant="h5" color="primary" gutterBottom>Pre - Transaction Details</Typography>
                </Col>
                <Col span={11}>
                    <div>
                        <TextField
                            label={boughtTree.customer_name.displayName}
                            value={dataModel.bought_info.customer_name || ''}
                            onChange={(event) => this.handleChangeField('bought_info.customer_name', event.target.value)}
                            disabled={(formIsLocked || isPaymentScreen || isLoading)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="text"
                        />
                    </div>
                    <div>
                        <TextField
                            label={custNameV5Tree.value.displayName}
                            value={dataModel.bought_info.customer_name_v5.value || ''}
                            onChange={(event) => this.handleChangeField('bought_info.customer_name_v5.value', event.target.value)}
                            disabled={(formIsLocked || dataModel.bought_info.customer_name_v5.is_locked || isPaymentScreen || isLoading)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="text"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.cash_amount.displayName}
                            value={dataModel.bought_info.cash_amount}
                            disabled={(formIsLocked || isPaymentScreen || isLoading || !boughtTree.cash_amount.isEditable)}
                            helperText={boughtTree.cash_amount.helperText}
                            onChange={(event) => this.handleChangeField('bought_info.cash_amount', event.target.value)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <Autocomplete
                            options={finTree.finance_company.enum}
                            getOptionLabel={(option) => option}
                            value={dataModel.finance_company || ''}
                            disabled={(formIsLocked || isPaymentScreen || isLoading)}
                            onChange={(event, value) => this.handleChangeField('finance_company', value)}
                            inputValue={dataModel.finance_company || ''}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    error={false}
                                    label={finTree.finance_company.displayName}
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    type="text"
                                />
                            )}
                        />
                    </div>
                    <div>
                        <TextField
                            label={finTree.finance_amount.displayName}
                            disabled={(formIsLocked || isPaymentScreen || isLoading || !finTree.finance_amount.isEditable)}
                            value={dataModel.finance_amount || ''}
                            onChange={(event) => this.handleChangeField('finance_amount', event.target.value)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <DatePicker
                                // disableToolbar
                                variant="inline"
                                inputVariant="outlined"
                                label={boughtTree.finance_expiry_date.displayName}
                                disabled={(formIsLocked || isPaymentScreen || isLoading || !boughtTree.finance_expiry_date.isEditable)}
                                value={dataModel.bought_info.finance_expiry_date || null}
                                onChange={(value) => this.handleChangeField('bought_info.finance_expiry_date', value.toISOString())}
                                // InputAdornment={{ position: 'end' }}
                                autoOk
                                format="D MMM YYYY"
                                margin="dense"
                                fullWidth
                                orientation="landscape"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <div>
                        <TextField
                            label={finTree.finance_agreement_number.displayName}
                            value={dataModel.finance_agreement_number || ''}
                            disabled={(formIsLocked || isPaymentScreen || isLoading || !finTree.finance_agreement_number.isEditable)}
                            onChange={(event) => this.handleChangeField('finance_agreement_number', event.target.value)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="text"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.negative_equity_amount.displayName}
                            disabled={(formIsLocked || isPaymentScreen || isLoading || !boughtTree.negative_equity_amount.isEditable)}
                            value={this.getValue('bought_info.negative_equity_amount', true, true)}
                            onChange={(event) => this.handleChangeField('bought_info.negative_equity_amount', event.target.value)}
                            inputProps={{ style: { backgroundColor: colorRed[50] } }}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.positive_equity_amount.displayName}
                            value={this.getValue('bought_info.positive_equity_amount', true, true)}
                            disabled={(formIsLocked || isPaymentScreen || isLoading || !boughtTree.positive_equity_amount.isEditable)}
                            onChange={(event) => this.handleChangeField('bought_info.positive_equity_amount', event.target.value)}
                            inputProps={{ style: { backgroundColor: colorGreen[50] } }}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="number"
                        />
                    </div>
                </Col>
                <Col span={2} />
                <Col span={11}>
                    <div>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    onChange={(event) => this.handleChangeField('bought_info.purchasing_team_approval.value', event.target.checked)}
                                    name={purchasingTree.value.displayName}
                                    checked={dataModel.bought_info.purchasing_team_approval ? dataModel.bought_info.purchasing_team_approval.value : false}
                                    disabled={formIsLocked || isLoading}
                                    color="primary"
                                />
                            )}
                            label={purchasingTree.value.displayName}
                        />
                        {
                            purApprovalHistory && <FormHelperText className={classes.checkboxHelperText}>{purApprovalHistory}</FormHelperText>
                        }
                    </div>
                    <div>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    onChange={(event) => this.handleChangeField('bought_info.transport_team_approval.value', event.target.checked)}
                                    name={transportTree.value.displayName}
                                    checked={dataModel.bought_info.transport_team_approval ? dataModel.bought_info.transport_team_approval.value : false}
                                    disabled={formIsLocked || isLoading}
                                    color="primary"
                                />
                            )}
                            label={transportTree.value.displayName}
                        />
                        {
                            transApprovalHistory && <FormHelperText className={classes.checkboxHelperText}>{transApprovalHistory}</FormHelperText>
                        }
                    </div>
                    <div>
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    onChange={(event) => this.handleChangeField('bought_info.accounts_team_approval.value', event.target.checked)}
                                    name={accountsTree.value.displayName}
                                    checked={dataModel.bought_info.accounts_team_approval ? dataModel.bought_info.accounts_team_approval.value : false}
                                    disabled={formIsLocked || isLoading}
                                    color="primary"
                                />
                            )}
                            label={accountsTree.value.displayName}
                        />
                        {
                            accApprovalHistory && <FormHelperText className={classes.checkboxHelperText}>{accApprovalHistory}</FormHelperText>
                        }
                    </div>
                    <div>
                        <TextField
                            label={boughtTree.payment_id.displayName}
                            value={dataModel.bought_info.payment_id || ''}
                            helperText={boughtTree.payment_id.helperText}
                            onChange={(event) => this.handleChangeField('bought_info.payment_id', event.target.value)}
                            fullWidth
                            disabled
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="text"
                        />
                    </div>
                    {
                        !isLoading && (
                            <div>
                                <Typography variant="subtitle1" gutterBottom>{ finTree.settlement_proof.displayName }</Typography>
                                <div className={classes.dropZoneWrapper}>
                                    <DropzoneAreaBase
                                        filesLimit={1}
                                        acceptedFiles={ACCEPTED_FILE_TYPES}
                                        // 5 MB
                                        maxFileSize={5000000}
                                        showPreviews
                                        showPreviewsInDropzone={false}
                                        useChipsForPreview
                                        previewChipProps={{
                                            onClick: this.handleDownloadFile,
                                        }}
                                        dropzoneText={null}
                                        dropzoneClass={(formIsLocked || isPaymentScreen) ? classes.dropZoneHiden : classes.dropZone}
                                        fileObjects={dataModel.settlement_proof ? [dataModel.settlement_proof] : []}
                                        previewText="Attachments"
                                        showAlerts={false}
                                        onAdd={this.handleUploadFile}
                                    />
                                </div>
                            </div>
                        )
                    }
                </Col>
            </Row>
        );
    }
}

export default withStyles(styles)(PreTransactionDetails);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/paymentApproval/PreTransactionDetails.js